import Survey from "../../../components/survey";

const SurveyFormScreen = () => {
  return (
    <div className="mb-2">
      <Survey />
    </div>
  );
};

export default SurveyFormScreen;
